// extracted by mini-css-extract-plugin
export default {"title":"NoCompaniesPage_title__xsONY","description":"NoCompaniesPage_description___51ou"};